document.addEventListener("DOMContentLoaded", function () {
  const baseId = "template--23762801852755__main";
  const formName = "product-form-template--23762801852755__main";
  const defaultFileUploadId = `${baseId}-file-upload-10`; // ID of the default upload section

  const fileUploadContainer = document.querySelector(".file-upload__inner");

  // Function to check if any variant options contain the '£' symbol
  function checkVariantOptionsForCurrencySymbol() {
    let containsCurrencySymbol = false;

    // Check radio buttons
    const radioOptions = document.querySelectorAll(
      ".option-selector input[type='radio'].js-option"
    );

    radioOptions.forEach((option) => {
      if (option.checked && option.value.includes("£")) {
        containsCurrencySymbol = true;
      }
    });

    // Check dropdown (custom-select)
    const selectedOption = document.querySelector(
      ".custom-select__listbox .custom-select__option[aria-selected='true']"
    );

    if (
      selectedOption &&
      selectedOption.getAttribute("data-value").includes("£")
    ) {
      containsCurrencySymbol = true;
    }

    // Toggle the file upload section based on the result
    toggleFileUploadSection(containsCurrencySymbol);
  }

  // Function to show or hide the file upload section and control required attributes
 function toggleFileUploadSection(show) {
    const fileUploadSection = document.querySelector(".file-upload");
    const fileInput = document.querySelector(".file-upload input[type='file']");
    const notesTextarea = document.querySelector(".file-upload-notes__textarea");

    // Select Express Checkout Buttons
    const expressCheckoutButtons = document.querySelectorAll(".shopify-payment-button, .product-info__dynamic-checkout-button");

    if (fileUploadSection) {
        if (show) {
            fileUploadSection.style.display = "block";
            if (fileInput) fileInput.required = false;
            if (notesTextarea) notesTextarea.required = true;

            // Hide Express Checkout Buttons
            expressCheckoutButtons.forEach(button => {
                button.style.display = "none";
            });

        } else {
            fileUploadSection.style.display = "none";
            if (fileInput) fileInput.required = false;
            if (notesTextarea) notesTextarea.required = false;

            // Show Express Checkout Buttons
            expressCheckoutButtons.forEach(button => {
                button.style.display = "block";
            });
        }
    }
}

  // Updated clearForm function to refresh the page
  window.clearForm = function () {
    location.reload(); // Refreshes the page, resetting all form fields
  };

  // Function to add a new file input above the Add/Remove buttons
  window.addFileInput = function () {
    const fileInputs =
      fileUploadContainer.querySelectorAll("input[type='file']");
    const lastFileInput = fileInputs[fileInputs.length - 1];

    if (!lastFileInput.files || lastFileInput.files.length === 0) {
      alert(
        "Please select a file in the previous upload field before adding another."
      );
      return;
    }

    const newIndex = fileInputs.length + 1;
    const newInputDiv = document.createElement("div");
    newInputDiv.classList.add("file-upload-field");
    newInputDiv.style.width = "100%";
    newInputDiv.style.marginBottom = "15px";

    const newLabel = document.createElement("label");
    newLabel.setAttribute("for", `${baseId}-file-upload-${newIndex}`);
    newLabel.classList.add("label");
    newLabel.style.fontWeight = "bold";
    newLabel.textContent = `Customisation File ${newIndex > 1 ? newIndex : ""}`;

    const newInput = document.createElement("input");
    newInput.type = "file";
    newInput.id = `${baseId}-file-upload-${newIndex}`;
    newInput.setAttribute(
      "name",
      `properties[Customisation File${newIndex > 1 ? " " + newIndex : ""}]`
    );
    newInput.setAttribute("form", formName);
    newInput.accept = "*";
    newInput.classList.add("input");
    newInput.style.width = "100%";
    newInput.style.boxSizing = "border-box";
    newInput.style.padding = "8px";

    newInputDiv.appendChild(newLabel);
    newInputDiv.appendChild(newInput);

    const buttonGroup = fileUploadContainer.querySelector(
      ".file-upload-buttons"
    );
    if (buttonGroup) {
      fileUploadContainer.insertBefore(newInputDiv, buttonGroup);
    } else {
      fileUploadContainer.appendChild(newInputDiv); // Fallback if buttonGroup is missing
    }
  };

  window.removeFileInput = function () {
    const fileInputs =
      fileUploadContainer.querySelectorAll(".file-upload-field");

    if (fileInputs.length === 0) {
      alert("The default file upload section cannot be removed.");
      return;
    }

    const lastFileInput = fileInputs[fileInputs.length - 1];
    const lastFileInputId =
      lastFileInput.querySelector("input[type='file']").id;

    if (lastFileInputId !== defaultFileUploadId) {
      lastFileInput.parentNode.removeChild(lastFileInput);
    } else {
      alert("The default file upload section cannot be removed.");
    }
  };

  // Initial check on page load
  checkVariantOptionsForCurrencySymbol();

  // Event listener for variant option changes
  const variantSelectors = document.querySelectorAll(
    ".option-selector input[type='radio'].js-option"
  );
  variantSelectors.forEach((selector) => {
    selector.addEventListener("change", checkVariantOptionsForCurrencySymbol);
  });

  // Event listener for custom dropdown changes
  const customSelectOptions = document.querySelectorAll(
    ".custom-select__option"
  );
  customSelectOptions.forEach((option) => {
    option.addEventListener("click", () => {
      // Update aria-selected attribute when an option is selected
      customSelectOptions.forEach((opt) =>
        opt.setAttribute("aria-selected", "false")
      );
      option.setAttribute("aria-selected", "true");
      checkVariantOptionsForCurrencySymbol();
    });
  });
});
